<template>
  <div class="wrapper">
    <div class="__container">
      <div class="form">
        <div class="logo">
          <img src="@/assets/images/logo/new_logo.svg" />
        </div>
        <div class="banner">
          <h1>Forgot password</h1>
          <span
            >Type your email, we will send you instructions on how to reset your
            password</span
          >
        </div>
        <div
          class="message"
          :class="{ success: emailSent, error: emailNotSent }"
          v-show="emailSent || emailNotSent"
        >
          <span v-if="emailNotSent">{{ errorMsg | validate }}</span>
          <span v-else>Link succesfully sent to your email</span>
        </div>
        <div class="login_form">
          <label class="label">E-mail</label>
          <widgetInput
            type="text"
            v-model="email"
            v-validate="'required'"
            placeholder="Type your E-mail"
          ></widgetInput>

          <div class="bottom">
            <widgetButton @click="submitEmail" class="btn-submit btn-secondary">
              Submit
            </widgetButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "reset",
  computed: {
    ...mapGetters([
      "getLocale",
      "getLoader",
      "getMessages",
      "getHelper",
      "getAlert",
      "getErrorMsg",
    ]),
    isPageReady() {
      // return true;
      return !(this.getMessages === null || this.getMessages === undefined);
    },

    pageContent() {
      return this.getMessages;
    },
    errorLoggingIn() {
      return this.getErrorMsg !== "";
    },
    errors() {
      return this.getErrorMsg;
    },
  },
  data() {
    return {
      email: "",
      emailSent: false,
      emailNotSent: false,
      errorMsg: "",
    };
  },
  methods: {
    submitEmail() {
      let vm = this;
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          vm.$startLoader();
          vm.$store
            .dispatch("FORGOT_PASSWORD", {
              email: vm.email,
              device_type: "web",
            })
            .then(function (response) {
              vm.emailSent = true;
              vm.emailNotSent = false;
            })
            .catch((error) => {
              vm.emailNotSent = true;
              vm.emailSent = false;
              vm.errorMsg = error.response.data.message;
            })
            .finally(() => {
              vm.$stopLoader();
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  position: relative;
  min-height: 100%;
  text-align: center;
  overflow: hidden;
  background-size: contain;
  z-index: 999999;
  background-repeat: no-repeat !important;
  background-position: center;
}
.__container {
  position: relative;
  display: inline-block;
  @media (min-width: 300px) and (max-width: 630px) {
  }
  .form {
    display: flex;
    align-items: center;
    flex-direction: column;
    .logo {
      margin-top: 80px;
      @media (min-width: 300px) and (max-width: 630px) {
        position: relative;
      }
    }
    .message {
      margin-top: 30px;
      border-radius: 5px;
      padding: 2px 40px;
      color: #fff;
    }
    .success {
      background: rgba(24, 133, 173, 0.3);
    }
    .error {
      background: rgba(128, 0, 0, 0.3);
    }
    .login_form {
      margin-top: 40px;
      text-align: left;
      width: 300px;
      display: flex;
      flex-direction: column;
      @media (min-width: 300px) and (max-width: 630px) {
        padding-left: 20px;
        padding-right: 20px;
      }
      .label-password {
        margin-top: 30px;
      }
      .label {
        color: #000;
        font-weight: lighter;
        font-size: 14px;
        margin-bottom: 5px;
        margin-left: 20px;
      }
      .error_input {
        border: 1px solid crimson !important;
        color: crimson;
      }
      .error-msg {
        color: crimson;
        text-align: left;
      }

      .bottom {
        display: flex;
        margin-top: 10px;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;

        .btn-submit {
          width: 100%;
          margin-top: 10px;
          cursor: pointer;
          margin-bottom: 10px;
        }
      }
    }
    .logo,
    .login_form {
      display: flex;
      flex-direction: column;
    }
    .banner {
      margin-top: 30px;
    }
    .banner span {
      font-size: 16px;
      color: #000000;
      font-weight: lighter;
    }
    .banner h1 {
      font-weight: normal;
      text-align: center;
      font-size: 30px;
      color: #1ba5a4;
      margin-bottom: 2rem !important;
    }
  }
}
</style>